import ResourceContent from './ResourceContent';

export default ResourceContent;
